import { fromJS } from 'immutable';
import { RestAPI } from '@/util/net.js';
import { markStoreLoading, markStoreLoaded } from '@/store/storeForStoringStatusOfStores.store';
import { putError } from '@/store/error.store';
import { fixDate, ifExists } from '../../../../util/util';
import momentLocalizer from 'react-widgets-moment';

import moment from 'moment';
moment.locale('en');
momentLocalizer();

export const profitabilityReducer = (state = fromJS({
  dateFrom: fixDate(moment().startOf('year').toDate()),
  dateTo: fixDate(moment().startOf('year').add(1, 'year').add(-1, 'day').toDate()),
}), action) => {
  switch (action.type) {
    case 'PROFITABILITY_LOADED':
      return state.set('totalProfitPurchase', fromJS(action.data)
        .map(d => d.set('value', d.get('valueOrigin'))))
        .set('totalProfitSale', fromJS(action.data)
          .map(d => d.set('value', d.get('valueDestination'))));
    case 'AVG_PER_TON_PROFIT_LOADED':
      return state.set('avgPerTonOrigin', fromJS(action.data)
        .map(d => d.set('avg per ton', d.get('avg per ton origin'))))
        .set('avgPerTonDestination', fromJS(action.data)
          .map(d => d.set('avg per ton', d.get('avg per ton destination'))));
    case 'AVG_COUNTRY_PER_TON_PROFIT_LOADED':
      return state.set('avgCountryPerTonOrigin', fromJS(action.data)
        .map(d => d.set('avg per ton', d.get('avg per ton origin')).set('avg total', d.get('avg total origin')))
        .sort((a, b) => b.get('avg total', 0) - a.get('avg total', 0))
        .filter(d => d.get('avg per ton') > 0))
        .set('avgCountryPerTonDestination', fromJS(action.data)
          .map(d => d.set('Average PMT', d.get('avg per ton destination')).set('Total', d.get('avg total destination')))
          .sort((a, b) => b.get('Total', 0) - a.get('Total', 0))
          .filter(d => d.get('Total') > 100000));
    case 'PROFITABILITY_UPDATE_DATE':
      return state.set('dateFrom', action.dateFrom).set('dateTo', action.dateTo);
    case 'SALE_PRODUCT_PROFIT_LOAD_COMPLETED':
      return state.set('totalSaleProfitProducts', fromJS(action.data).map(d => d.set('value', d.get('Profit'))));
    default:
      return state;
  }
};

const requestFailure = (dispatch, type, data, reportType) => {
  putError(dispatch, data);
  dispatch({ type });
  markStoreLoaded(dispatch, reportType);
  return true;
};

const requestSuccess = (dispatch, type, data, reportType) => {
  dispatch({ type, data });
  markStoreLoaded(dispatch, reportType);
  return true;
};

const dateOrEmpty = (date) => ifExists(date).map(d => d.getTime()).orElse('');

export const loadTotalProfitability = (dispatch, dateFrom, dateTo) => {
  dispatch({ type: 'LOADING_PROFITABILITY_REPORT' });
  const reportType = 'PROFITABILITY';
  markStoreLoading(dispatch, reportType);
  return RestAPI.get(`/api/report/profitability?from=${dateOrEmpty(dateFrom)}&to=${
    dateOrEmpty(dateTo)}`)
    .then(data =>
      requestSuccess(dispatch, 'PROFITABILITY_LOADED', data, reportType))
    .catch(data =>
      requestFailure(dispatch, 'PROFITABILITY_LOADING_FAILED',
        data, reportType));
};

export const loadAvgPerTonProfit = (dispatch, dateFrom, dateTo) => {
  dispatch({ type: 'LOADING_AVG_PER_TON_PROFIT' });
  const reportType = 'AVG_PER_TON_PROFIT';
  markStoreLoading(dispatch, reportType);
  return RestAPI.get(`/api/report/avgpertonprofit?from=${
    dateOrEmpty(dateFrom)}&to=${dateOrEmpty(dateTo)}`)
    .then(data =>
      requestSuccess(dispatch, 'AVG_PER_TON_PROFIT_LOADED',
        data, reportType))
    .catch(data =>
      requestFailure(dispatch,
        'AVG_PER_TON_PROFIT_LOADING_FAILED', data, reportType));
};

export const loadCountryAvgPerTonProfit = (dispatch, dateFrom, dateTo) => {
  dispatch({ type: 'LOADING_AVG_COUNTRY_PER_TON_PROFIT' });
  const reportType = 'AVG_COUNTRY_PER_TON_PROFIT';
  markStoreLoading(dispatch, reportType);
  return RestAPI.get(`/api/report/avgpertonprofitcountry?from=${
    dateOrEmpty(dateFrom)}&to=${dateOrEmpty(dateTo)}`)
    .then(data =>
      requestSuccess(dispatch, 'AVG_COUNTRY_PER_TON_PROFIT_LOADED',
        data, reportType))
    .catch(data =>
      requestFailure(dispatch,
        'AVG_COUNTRY_PER_TON_PROFIT_LOADING_FAILED', data, reportType));
};

export const totalProfitByProduct = (dispatch, dealType, dateFrom, dateTo) => {
  dispatch({ type: `${dealType.toUpperCase()}_PRODUCT_PROFIT_LOAD_STARTING` });
  const reportType = `${dealType.toUpperCase()}_PRODUCT_PROFIT`;
  markStoreLoading(dispatch, reportType);
  return RestAPI.get(`/api/report/totalquantityvsprofitbyproduct?dealType=${dealType}&from=${
    dateOrEmpty(dateFrom)}&to=${dateOrEmpty(dateTo)}`)
    .then(
      data => requestSuccess(dispatch,
        `${dealType.toUpperCase()}_PRODUCT_PROFIT_LOAD_COMPLETED`, data, reportType),
    ).catch(
      data => requestFailure(dispatch,
        `${dealType.toUpperCase()}_PRODUCT_PROFIT_LOADING_FAILED`, data, reportType),
    );
};

export const profitabilityLoad = (dispatch, dateFrom, dateTo) => {
  loadTotalProfitability(dispatch, dateFrom, dateTo);
  loadAvgPerTonProfit(dispatch, dateFrom, dateTo);
  loadCountryAvgPerTonProfit(dispatch, dateFrom, dateTo);
};

export const updateDate = (dispatch, dateFrom, dateTo) => {
  dispatch({ type: 'PROFITABILITY_UPDATE_DATE', dateFrom, dateTo });
};
